
import { defineComponent } from "vue";
import { footerWidthFluid } from "@/core/helpers/config";

export default defineComponent({
  name: "KTFooter",
  currentYear: null,

  setup() {

    const currentYear = new Date().getFullYear(); 

    return {
      footerWidthFluid,
      currentYear,
    };
  },
});
